import "./FoodInfo.css";

import FoodPrice from "../FoodPrice/FoodPrice";
import FoodStatusBadge from "../FoodStatusBadge/FoodStatusBadge";

function FoodInfo({ food }) {
  return (
    <div className="food-info">

      <h3>{food.foodName}</h3>

      <p>{food.category}</p>

      <FoodPrice food={food} />

      <FoodStatusBadge
        isAvailable={food.isAvailable}
      />

    </div>
  );
}

export default FoodInfo;